// ============================================================================
// Hook: useRectaScriptaIndex
// Carrega o índice consolidado da Recta Scripta (gerado por
// scripts/python_tools/recta_scripta/gera_recta_scripta_index.py).
//
// FASE 2 (auditoria 10/09/2026): antes vivia em /public/data/recta_scripta_index.json,
// servido estaticamente pelo Vite — o que expunha clientes, fornecedores e CNPJs SEM
// login no site publicado. Agora vem do Firestore
// (artifacts/portalrda-f312d/public/data/private_datasets/recta_scripta_index),
// admin-only pela regra K do firestore.rules. Cache em memória (um fetch por sessão).
// ============================================================================
import { useState, useEffect } from 'react';
import { loadPrivateDataset, clearPrivateDatasetCache, DATASET } from '../../../shared/api/privateDatasets';

export function clearRectaScriptaIndexCache() {
  clearPrivateDatasetCache(DATASET.SCRIPTA_INDEX);
}

export function useRectaScriptaIndex() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    loadPrivateDataset(DATASET.SCRIPTA_INDEX)
      .then((json) => {
        if (cancelled) return;
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
}

// Helpers de seleção (memoizáveis no componente que consumir)
export function findClienteById(index, id) {
  if (!index || !id) return null;
  return (index.clientes || []).find((c) => c.id === id) || null;
}

export function findEmissorById(index, id) {
  if (!index || !id) return null;
  return (index.emissores || []).find((e) => e.id === id) || null;
}

export function findFornecedorById(index, id) {
  if (!index || !id) return null;
  return (index.fornecedores || []).find((f) => f.id === id) || null;
}

export function findProdutoById(index, id) {
  if (!index || !id) return null;
  return (index.produtos || []).find((p) => p.id === id) || null;
}

export function eventosDeProposta(index, propostaId) {
  if (!index || !propostaId) return [];
  return (index.eventos || []).filter((e) => e.proposta_id === propostaId);
}
